import { useState, useEffect } from "react";
import throttle from 'lodash.throttle';

const MIN_ZOOM = -1;
const MAX_ZOOM = 2;

const useZoomLevel = () => {
  const [zoom, setZoom] = useState<number>(2);

  useEffect(() => {
    const getScroll = (e: any) => {
      const delta = Math.sign(e.deltaY);
      setZoom((currentZoom: number) => {
        const newZoom = Math.max(MIN_ZOOM, Math.min(currentZoom + delta, MAX_ZOOM));
        return Math.min(newZoom);
      });
    };

    const throttledScroll = throttle(getScroll, 100);

    window.addEventListener("wheel", throttledScroll);

    return function cleanup() {
      window.removeEventListener("wheel", throttledScroll);
    };
  }, []);

  return zoom;
};

export default useZoomLevel;
